import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, NAV, FOOTER } from "../../data/site";

const Col = ({ title, items }) => (
  <div>
    <p className="overline-x mb-5">{title}</p>
    <ul className="space-y-2.5">
      {items.map((it) => (
        <li key={it.to + it.label}>
          <Link to={it.to} className="text-sm text-white/55 hover:text-white transition-colors">
            {it.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#030710] border-t border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2 pr-8">
          <p className="font-display font-800 tracking-tighter text-2xl text-white" style={{ fontWeight: 800 }}>
            CEDAR VIEWS
          </p>
          <p className="font-mono-x text-[9px] tracking-[0.3em] text-white/40 mt-1 mb-6">ARCHITECTURAL GLAZING</p>
          <p className="text-sm text-white/55 leading-relaxed max-w-sm">{FOOTER.blurb}</p>
          <div className="mt-8 space-y-3 text-sm text-white/70">
            <a href={CONTACT.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white transition-colors">
              <Phone size={14} /> {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-white transition-colors">
              <Mail size={14} /> {CONTACT.email}
            </a>
            <p className="flex items-start gap-3">
              <MapPin size={14} className="mt-1 shrink-0" /> {(CONTACT.address || []).join(", ")}
            </p>
          </div>
        </div>
        <Col title="Windows" items={NAV.windows} />
        <Col title="Doors" items={NAV.doors} />
        <Col title="Company" items={FOOTER.company} />
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-xs text-white/35">© {new Date().getFullYear()} {FOOTER.copyright}</p>
        <p className="font-mono-x text-[10px] tracking-[0.2em] text-white/35 uppercase">
          Rated {CONTACT.rating} · {CONTACT.reviews} reviews
        </p>
      </div>
    </div>
  </footer>
);
